// extracted by mini-css-extract-plugin
export default {"card":"HighlightCard_card__QFlvc","logoWrapper":"HighlightCard_logoWrapper__zpDk5","logo":"HighlightCard_logo__guttS","text":"HighlightCard_text__GVoGJ","x":"HighlightCard_x__xMfe0"};